export const addDeploymentToast = (_label: string, locale?: string, contentHash?: string) => {
  if (locale && contentHash) {
    const cookieValue = encodeURIComponent(JSON.stringify({ locale, contentHash }));
    document.cookie = `waiting-for-deploy=${cookieValue}; path=/`;
    window.dispatchEvent(new Event('waiting-for-deploy'));
  }

  location.reload();
};
